// Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
import { HolidayService } from '../../../../holiday/services/HolidayService';
// Models
import { User } from '../models/User';
import { Parent } from '../../../../holiday/models/Parent';
import { Credential } from '../models/Credential';
import { SessionStorageService } from '../../core/services';
import { procEnv, devEnv, testEnv, stagingEnv, localEnv, demoEnv, bisHanoiEnv, bisHanoiDevEnv } from '../../../config/config';
@Component({
    selector: 'user-login',
    template: require('./HolLoginComponent.html'),
    styles: [require('./HolLoginComponent.sass')],
})

export class HolLoginComponent implements OnInit {
    credential:     Credential;
    parent:     Parent;
    message:        string;
    messageType:    string;
    redirectUrl:    string;
    formSubmitted: boolean = false;
    selectedTab: number;
    schools: any;
    hostName: any;
    
    constructor(
        private holidayService: HolidayService,
        private sessionService: SessionService,
        private userService: UserService,
        private router: Router,
        private sessionStorageService: SessionStorageService
    ) {
        this.credential = new Credential('', '', '');
        this.parent = new Parent();
    }

    ngOnInit() {
        this.hostName = window.location.hostname
        // Use Session Service to get session and check if user had already logged in.
        this.getSession();
        this.schools = [
            {
                name: 'Helen School',
                value: 1,
            },
            {
                name: 'Others',
                value: 2,
            },
        ]
        this.schools.value = 1;
        this.selectedTab = 1;
    };

    onSubmit() {
        this.credential.role = 'parent'
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.postSession(this.credential);
    }

    onSubmitNonVas() {
        this.credential.role = 'hol-parent'
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.postSessionNonVas(this.credential);
    }

    /**
     * Get Session from API service to make sure that user had logged in.
     * Update User Data on local storage and redirect to the desired URL 
     * if request responses session data.
     * @param none
     * @return none
     */
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    /**
     * Post Session to API service to create new session.
     * Update User Data on local storage and redirect to desired URL
     * if request responses session data.
     * @param {Credential} - user credential input
     * @return none
     */

    private postSession(credential: Credential) {
        this.sessionService.postSession(credential)
            .subscribe(
                user    => {
                    this.sessionStorageService.setData('isVasParent', true);
                    // Set user session data
                    this.userService.setUserSessionData(user);
                    // Fire user session data changed event
                    this.userService.userDataChanged(user);
                    this.router.navigate(['/parents'])
                },
                error   => {
                    this.formSubmitted = false;
                    this.message = "Invalid email address or password.";
                    this.messageType = "alert";
                }
            );
    }

    private postSessionNonVas(credential: Credential) {
        this.sessionService.postSession(credential)
            .subscribe(
                user    => {
                    this.sessionStorageService.setData('isVasParent', false);
                    // Set user session data
                    this.userService.setUserSessionData(user);
                    // Fire user session data changed event
                    this.userService.userDataChanged(user);
                    // this.checkStatus();
                    this.router.navigate(['/other-parents'])
                },
                error   => {
                    this.formSubmitted = false;
                    this.message = "Invalid email address or password.";
                    this.messageType = "alert";
                }
            );
    }
    
    toHoliday() {
        switch(this.hostName){
            case procEnv.services:
                window.location.href = `https://${procEnv.holiday}`;
                break;
            case bisHanoiDevEnv.services:
                window.location.href = `http://${bisHanoiDevEnv.holiday}`;
                break;
            case bisHanoiEnv.services:
                window.location.href = `http://${bisHanoiEnv.holiday}`;
                break;
            case devEnv.services:
                window.location.href = `http://${devEnv.holiday}`;
                break;
            case testEnv.services:
                window.location.href = `http://${testEnv.holiday}`;
                break;
            case stagingEnv.services:
                window.location.href = `https://${stagingEnv.holiday}`;
                break;
            case demoEnv.services:
            window.location.href = `http://${demoEnv.holiday}`;
            break;
            case localEnv.services:
                window.location.href = `http://${localEnv.holiday}`;
                break;
        };
    }

    private activateTab(tabId: number) {
        this.selectedTab = tabId;
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/hol-login/HolLoginComponent.ts